import { media } from '@payright/web-components';
import styled from 'styled-components';

export const SubFormContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;

  .label-with-tooltip {
    display: flex;
    flex-wrap: wrap;
    column-gap: 0.5rem;
    row-gap: 0.5rem;
    align-items: baseline;

    .label-secondary {
      width: 100%;
      color: ${(props) => props.theme.colours.plum.light};
      font-weight: lighter;
    }
  }

  .underline {
    text-decoration: underline;
  }
`;

export const SubFormFields = styled.div`
  display: grid;
  gap: 1.5rem;
  grid-template-columns: auto;

  .grid-all-column {
    grid-column: 1 / -1;
  }

  ${media.min.medium} {
    grid-template-columns: repeat(2, minmax(10px, 1fr));
  }
`;
